// src/utils/authUtils.ts

import * as AmplifyModules from 'aws-amplify/auth';
// import { Auth } from 'aws-amplify';

/**
 * Function to retrieve id_token from Cognito
 * @returns {Promise<string | null>} - The id_token if authenticated, otherwise null
 */
export async function getIdToken(): Promise<string | null> {
  try {
    const currentSession = await AmplifyModules.fetchAuthSession();
    const idToken = currentSession.tokens?.idToken?.toString() || '';
    return idToken;
  } catch (error) {
    console.error("Error getting id_token:", error);
    return null;
  }
}
